import {FC, SVGProps} from "react"
import {articleChevronColours} from "../../theme"

type IconProps = SVGProps<SVGSVGElement>

export const DashboardIcon: FC<IconProps> = (props) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_9421_68249)">
      <g clipPath="url(#clip1_9421_68249)">
        <path
          d="M18.7502 20H1.90805C1.03436 20 0.329102 19.2947 0.329102 18.4211V1.57895C0.329102 0.705263 1.03436 0 1.90805 0H18.7502C19.6238 0 20.3291 0.705263 20.3291 1.57895V18.4211C20.3291 19.2947 19.6238 20 18.7502 20ZM1.90805 1.05263C1.61331 1.05263 1.38173 1.28421 1.38173 1.57895V18.4211C1.38173 18.7158 1.61331 18.9474 1.90805 18.9474H18.7502C19.0449 18.9474 19.2765 18.7158 19.2765 18.4211V1.57895C19.2765 1.28421 19.0449 1.05263 18.7502 1.05263H1.90805Z"
          fill="#595958"
        />
        <path
          d="M7.17113 16.8421H5.06587C4.77113 16.8421 4.53955 16.6105 4.53955 16.3158V6.84211C4.53955 6.54737 4.77113 6.3158 5.06587 6.3158H7.17113C7.46587 6.3158 7.69745 6.54737 7.69745 6.84211V16.3158C7.69745 16.6105 7.46587 16.8421 7.17113 16.8421ZM5.59218 15.7895H6.64481V7.36843H5.59218V15.7895Z"
          fill="#595958"
        />
        <path
          d="M11.3816 16.842H9.27632C8.98158 16.842 8.75 16.6105 8.75 16.3157V3.68415C8.75 3.38942 8.98158 3.15784 9.27632 3.15784H11.3816C11.6763 3.15784 11.9079 3.38942 11.9079 3.68415V16.3157C11.9079 16.6105 11.6763 16.842 11.3816 16.842ZM9.80263 15.7894H10.8553V4.21047H9.80263V15.7894Z"
          fill="#595958"
        />
        <path
          d="M15.592 16.8422H13.4868C13.192 16.8422 12.9604 16.6106 12.9604 16.3158V11.0527C12.9604 10.7579 13.192 10.5264 13.4868 10.5264H15.592C15.8868 10.5264 16.1183 10.7579 16.1183 11.0527V16.3158C16.1183 16.6106 15.8868 16.8422 15.592 16.8422ZM14.0131 15.7895H15.0657V11.579H14.0131V15.7895Z"
          fill="#595958"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_9421_68249">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.329102)"
        />
      </clipPath>
      <clipPath id="clip1_9421_68249">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.329102)"
        />
      </clipPath>
    </defs>
  </svg>
)

export const FileIcon: FC<IconProps> = (props) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.4968 20C8.01677 20 5.99677 17.98 5.99677 15.5V3.5C5.99677 1.57 7.56677 0 9.49677 0C11.4268 0 12.9968 1.57 12.9968 3.5V14.5C12.9968 15.88 11.8768 17 10.4968 17C9.11677 17 7.99677 15.88 7.99677 14.5V8.5C7.99677 8.22 8.21677 8 8.49677 8C8.77677 8 8.99677 8.22 8.99677 8.5V14.5C8.99677 15.33 9.66677 16 10.4968 16C11.3268 16 11.9968 15.33 11.9968 14.5V3.5C11.9968 2.12 10.8768 1 9.49677 1C8.11677 1 6.99677 2.12 6.99677 3.5V15.5C6.99677 17.43 8.56677 19 10.4968 19C12.4268 19 13.9968 17.43 13.9968 15.5V8.5C13.9968 8.22 14.2168 8 14.4968 8C14.7768 8 14.9968 8.22 14.9968 8.5V15.5C14.9968 17.98 12.9768 20 10.4968 20Z"
      fill="#7E8081"
    />
  </svg>
)

export const FolderIcon: FC<IconProps> = (props) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 15"
    height="20"
    width="20"
    {...props}
  >
    <g id="Layer_1-2" data-name="Layer 1">
      <path
        className="cls-1"
        strokeWidth="0px"
        d="m18.5,2h-7.5c-.09,0-.24-.09-.28-.17l-.55-1.11c-.21-.41-.71-.72-1.17-.72H2c-.46,0-.96.31-1.17.72L.28,1.83c-.16.31-.28.82-.28,1.17v10.5c0,.83.67,1.5,1.5,1.5h17c.83,0,1.5-.67,1.5-1.5V3.5c0-.83-.67-1.5-1.5-1.5Zm.5,11.5c0,.28-.22.5-.5.5H1.5c-.28,0-.5-.22-.5-.5V3c0-.2.08-.55.17-.72l.55-1.11c.04-.08.19-.17.28-.17h7c.09,0,.24.09.28.17l.55,1.11c.21.41.71.72,1.17.72h7.5c.28,0,.5.22.5.5v10Z"
      />
    </g>
  </svg>
)

export const PuzzleIcon: FC<IconProps> = (props) => (
  <svg
    width={props.width || "15"}
    height={props.height || "16"}
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#63b3qv8toa)">
      <path
        d="M13.94 4.054a.402.402 0 0 0-.391-.016s-.656.328-1.407.576c-1.264.407-1.712.264-1.848.176-.048-.032-.16-.096-.16-.392 0-.248.128-.472.288-.744.232-.392.512-.887.512-1.655 0-.536-.368-1.063-1.015-1.44C9.31.2 8.535 0 7.736 0c-.8 0-1.576.2-2.183.56-.648.384-1.016.911-1.016 1.439 0 .768.288 1.263.512 1.655.16.272.288.496.288.744 0 .216-.08.296-.152.352-.16.104-.704.303-2.31-.12a14.21 14.21 0 0 1-1.784-.6.41.41 0 0 0-.336.008.387.387 0 0 0-.208.264C.54 4.342.3 5.285.14 6.349-.164 8.396.092 9.004.307 9.283c.16.2.376.312.624.312.544 0 .904-.416 1.247-.815.344-.4.672-.784 1.152-.784.48 0 1.2.96 1.2 2.399 0 1.44-.72 2.399-1.2 2.399s-.808-.376-1.152-.784c-.343-.4-.703-.816-1.247-.816a.804.804 0 0 0-.664.336c-.2.264-.423.816-.112 2.511.16.871.384 1.631.4 1.671A.403.403 0 0 0 .94 16h11.195a2 2 0 0 0 1.998-1.999V4.39a.393.393 0 0 0-.191-.336zm-.607 9.931c0 .664-.536 1.2-1.2 1.2H1.243c-.088-.32-.224-.856-.32-1.424-.256-1.487-.016-1.759 0-1.775H.94c.176 0 .416.272.64.544.408.472.911 1.055 1.759 1.055.536 0 1.063-.368 1.447-1.015.36-.608.552-1.384.552-2.183 0-.8-.2-1.575-.552-2.183-.384-.648-.911-1.016-1.447-1.016-.848 0-1.351.584-1.76 1.056-.223.264-.455.536-.63.536-.04-.048-.28-.432-.025-2.215.088-.632.216-1.248.304-1.64.344.128.864.312 1.431.456 1.44.384 2.407.384 2.967.016.232-.152.511-.455.511-1.015 0-.464-.2-.808-.391-1.144-.208-.36-.408-.703-.408-1.255 0-.48.96-1.2 2.399-1.2s2.398.72 2.398 1.2c0 .552-.2.896-.407 1.255-.192.336-.392.68-.392 1.144 0 .607.296.92.544 1.071.52.32 1.343.288 2.526-.096.352-.112.672-.24.936-.352v8.972l-.008.008z"
        fill={props.fill || "#053747"}
      />
    </g>
    <defs>
      <clipPath id="63b3qv8toa">
        <path fill="#fff" d="M0 0h14.133v16H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const EmailIcon: FC<IconProps> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.737 6.947H5.263C4.564 6.947 4 7.512 4 8.211v7.579c0 .698.564 1.263 1.263 1.263h13.474c.699 0 1.263-.565 1.263-1.264V8.212c0-.7-.564-1.264-1.263-1.264zm0 .842h.076l-6.341 4.228c-.245.16-.69.16-.935 0l-6.35-4.22h13.55V7.79zm0 8.421H5.263a.417.417 0 0 1-.42-.42V8.573l6.222 4.151c.261.177.598.261.935.261.337 0 .674-.084.935-.26l6.223-4.152v7.216a.417.417 0 0 1-.421.421z"
      fill="#053747"
    />
  </svg>
)

export const AccessDeniedIcon: FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="62"
    height="44"
    viewBox="0 0 62 44"
    fill="none"
    {...props}
  >
    <path
      d="M22.2416 34.8827H22.3103C24.6675 36.9777 27.7356 38.0936 30.8875 38.0027C34.0399 37.9118 37.0387 36.6211 39.2712 34.3938C41.5039 32.1665 42.8017 29.1709 42.9001 26.0189C42.9985 22.867 41.8897 19.7963 39.8003 17.434V17.3653H39.7316C37.3909 15.1734 34.2909 13.9759 31.0845 14.0249C27.8782 14.0737 24.8162 15.3653 22.5436 17.6274C20.271 19.8895 18.9649 22.9454 18.9009 26.1513C18.8369 29.3574 20.0198 32.4631 22.2005 34.8138L22.2416 34.8827ZM31.0003 35.749C28.9271 35.743 26.9114 35.0679 25.2528 33.824L38.7003 20.3765C40.1269 22.2929 40.7899 24.6712 40.5602 27.0491C40.3305 29.427 39.2247 31.6347 37.4578 33.2426C35.691 34.8505 33.3893 35.7439 31.0003 35.749ZM31.0003 16.499C33.0735 16.505 35.0892 17.1801 36.7478 18.424L23.3003 31.8715C21.8737 29.9551 21.2107 27.5768 21.4404 25.1989C21.6701 22.821 22.7759 20.6133 24.5428 19.0054C26.3096 17.3975 28.6113 16.5041 31.0003 16.499Z"
      fill="#E83C4E"
    />
    <path
      d="M59.875 0H2.12501C1.76042 0 1.41067 0.144804 1.15283 0.402831C0.894804 0.660643 0.75 1.01042 0.75 1.37501V42.625C0.75 42.9896 0.894804 43.3393 1.15283 43.5972C1.41064 43.8552 1.76042 44 2.12501 44H59.875C60.2396 44 60.5893 43.8552 60.8472 43.5972C61.1052 43.3394 61.25 42.9896 61.25 42.625V1.37501C61.25 1.01042 61.1052 0.660671 60.8472 0.402831C60.5894 0.144804 60.2396 0 59.875 0ZM14.5 4.125C14.8646 4.125 15.2143 4.2698 15.4722 4.52783C15.7302 4.78564 15.875 5.13541 15.875 5.50001C15.875 5.8646 15.7302 6.21435 15.4722 6.47219C15.2144 6.73021 14.8646 6.87502 14.5 6.87502C14.1354 6.87502 13.7857 6.73021 13.5278 6.47219C13.2698 6.21438 13.125 5.8646 13.125 5.50001C13.125 5.13541 13.2698 4.78567 13.5278 4.52783C13.7856 4.2698 14.1354 4.125 14.5 4.125ZM10.375 4.125C10.7396 4.125 11.0893 4.2698 11.3472 4.52783C11.6052 4.78564 11.75 5.13541 11.75 5.50001C11.75 5.8646 11.6052 6.21435 11.3472 6.47219C11.0894 6.73021 10.7396 6.87502 10.375 6.87502C10.0104 6.87502 9.66067 6.73021 9.40283 6.47219C9.1448 6.21438 9 5.8646 9 5.50001C9 5.13541 9.1448 4.78567 9.40283 4.52783C9.66064 4.2698 10.0104 4.125 10.375 4.125ZM6.25001 4.125C6.6146 4.125 6.96435 4.2698 7.22219 4.52783C7.48022 4.78564 7.62502 5.13541 7.62502 5.50001C7.62502 5.8646 7.48022 6.21435 7.22219 6.47219C6.96438 6.73021 6.6146 6.87502 6.25001 6.87502C5.88541 6.87502 5.53567 6.73021 5.27783 6.47219C5.0198 6.21438 4.875 5.8646 4.875 5.50001C4.875 5.13541 5.0198 4.78567 5.27783 4.52783C5.53564 4.2698 5.88541 4.125 6.25001 4.125ZM58.5 41.25H3.50001V11H58.5V41.25Z"
      fill="#E83C4E"
    />
  </svg>
)

export const UnexpectedErrorIcon: FC<IconProps> = (props) => (
  <svg
    width="62"
    height="44"
    viewBox="0 0 62 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M59.875 0H2.12501C1.76042 0 1.41067 0.144804 1.15283 0.402831C0.894804 0.660643 0.75 1.01042 0.75 1.37501V42.625C0.75 42.9896 0.894804 43.3393 1.15283 43.5972C1.41064 43.8552 1.76042 44 2.12501 44H59.875C60.2396 44 60.5893 43.8552 60.8472 43.5972C61.1052 43.3394 61.25 42.9896 61.25 42.625V1.37501C61.25 1.01042 61.1052 0.660671 60.8472 0.402831C60.5894 0.144804 60.2396 0 59.875 0ZM14.5 4.125C14.8646 4.125 15.2143 4.2698 15.4722 4.52783C15.7302 4.78564 15.875 5.13541 15.875 5.50001C15.875 5.8646 15.7302 6.21435 15.4722 6.47219C15.2144 6.73021 14.8646 6.87502 14.5 6.87502C14.1354 6.87502 13.7857 6.73021 13.5278 6.47219C13.2698 6.21438 13.125 5.8646 13.125 5.50001C13.125 5.13541 13.2698 4.78567 13.5278 4.52783C13.7856 4.2698 14.1354 4.125 14.5 4.125ZM10.375 4.125C10.7396 4.125 11.0893 4.2698 11.3472 4.52783C11.6052 4.78564 11.75 5.13541 11.75 5.50001C11.75 5.8646 11.6052 6.21435 11.3472 6.47219C11.0894 6.73021 10.7396 6.87502 10.375 6.87502C10.0104 6.87502 9.66067 6.73021 9.40283 6.47219C9.1448 6.21438 9 5.8646 9 5.50001C9 5.13541 9.1448 4.78567 9.40283 4.52783C9.66064 4.2698 10.0104 4.125 10.375 4.125ZM6.25001 4.125C6.6146 4.125 6.96435 4.2698 7.22219 4.52783C7.48022 4.78564 7.62502 5.13541 7.62502 5.50001C7.62502 5.8646 7.48022 6.21435 7.22219 6.47219C6.96438 6.73021 6.6146 6.87502 6.25001 6.87502C5.88541 6.87502 5.53567 6.73021 5.27783 6.47219C5.0198 6.21438 4.875 5.8646 4.875 5.50001C4.875 5.13541 5.0198 4.78567 5.27783 4.52783C5.53564 4.2698 5.88541 4.125 6.25001 4.125ZM58.5 41.25H3.50001V11H58.5V41.25Z"
      fill="#E83C4E"
    />
    <path
      d="M19.7995 35.8565L19.7996 35.8565L19.796 35.8504C19.7361 35.7506 19.732 35.6169 19.7995 35.4968L30.6857 16.1437L30.4695 16.0221L30.6857 16.1437C30.7477 16.0334 30.8552 15.9688 31 15.9688C31.136 15.9688 31.2498 16.0382 31.3162 16.1471L42.2005 35.4968C42.2659 35.6132 42.2665 35.7369 42.2022 35.8534C42.1342 35.9645 42.0195 36.0315 41.8982 36.0315H41.874H20.1018C19.9719 36.0315 19.8629 35.9692 19.7995 35.8565ZM20.9241 34.9494L20.7147 35.3219H21.142H40.8459H41.2735L41.0638 34.9493L31.2058 17.4347L30.9878 17.0474L30.77 17.4348L20.9241 34.9494Z"
      fill="#E83C4E"
      stroke="#E83C4E"
      strokeWidth="0.5"
    />
    <path
      d="M30.9878 29.9835C30.7872 29.9835 30.6331 29.8293 30.6331 29.6287V23.5809C30.6331 23.3803 30.7872 23.2261 30.9878 23.2261C31.1885 23.2261 31.3426 23.3803 31.3426 23.5809V29.6287C31.3426 29.8293 31.1885 29.9835 30.9878 29.9835Z"
      fill="#E83C4E"
      stroke="#E83C4E"
      strokeWidth="0.5"
    />
    <path
      d="M30.9878 33.6125C30.7872 33.6125 30.6331 33.4583 30.6331 33.2577V32.0481C30.6331 31.8475 30.7872 31.6934 30.9878 31.6934C31.1885 31.6934 31.3426 31.8475 31.3426 32.0481V33.2577C31.3426 33.4583 31.1885 33.6125 30.9878 33.6125Z"
      fill="#E83C4E"
      stroke="#E83C4E"
      strokeWidth="0.5"
    />
  </svg>
)

export const ErrorIcon: FC<IconProps> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 12C0 5.37264 5.37264 0 12 0C18.6274 0 24 5.37264 24 12C24 18.6274 18.6274 24 12 24C5.37264 24 0 18.6274 0 12ZM12 2.4C6.69816 2.4 2.4 6.69816 2.4 12C2.4 17.3018 6.69816 21.6 12 21.6C17.3018 21.6 21.6 17.3018 21.6 12C21.6 6.69816 17.3018 2.4 12 2.4Z"
      fill="#DB0D00"
    />
    <path
      d="M16.7999 8.24762L15.7525 7.2002L11.5999 11.3528L7.44733 7.2002L6.3999 8.24762L10.5525 12.4002L6.3999 16.5528L7.44733 17.6002L11.5999 13.4476L15.7525 17.6002L16.7999 16.5528L12.6473 12.4002L16.7999 8.24762Z"
      fill="#DB0D00"
    />
  </svg>
)

export const SuccessIcon: FC<IconProps> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_9227_1706)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12C0 5.37264 5.37264 0 12 0C18.6274 0 24 5.37264 24 12C24 18.6274 18.6274 24 12 24C5.37264 24 0 18.6274 0 12ZM12 2.4C6.69816 2.4 2.4 6.69816 2.4 12C2.4 17.3018 6.69816 21.6 12 21.6C17.3018 21.6 21.6 17.3018 21.6 12C21.6 6.69816 17.3018 2.4 12 2.4Z"
        fill="#58A733"
      />
      <g clip-path="url(#clip1_9227_1706)">
        <path
          d="M6.82017 11.6183L6.75249 11.5561L6.68481 11.6183L5.69208 12.5311L5.61202 12.6047L5.69208 12.6783L9.66299 16.3291L9.73067 16.3914L9.79836 16.3291L18.3074 8.50586L18.3875 8.43225L18.3074 8.35863L17.3147 7.44592L17.247 7.38369L17.1794 7.44592L9.73067 14.2943L6.82017 11.6183Z"
          fill="#58A733"
          stroke="#58A733"
          strokeWidth="0.2"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_9227_1706">
        <rect width="24" height="24" fill="white" />
      </clipPath>
      <clipPath id="clip1_9227_1706">
        <rect
          width="12.8"
          height="12.8"
          fill="white"
          transform="translate(5.59961 5.59961)"
        />
      </clipPath>
    </defs>
  </svg>
)

export const SearchIcon: FC<IconProps> = (props) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 19 20"
    {...props}
  >
    <g id="Layer_1-2" data-name="Layer 1">
      <path
        className="cls-1"
        strokeWidth="0px"
        d="m18.87,19.16l-5.94-6.48c1.34-1.4,2.08-3.23,2.08-5.18s-.78-3.89-2.2-5.3c-1.42-1.42-3.3-2.2-5.3-2.2S3.61.78,2.2,2.2C.78,3.61,0,5.5,0,7.5s.78,3.89,2.2,5.3,3.3,2.2,5.3,2.2c1.73,0,3.36-.58,4.69-1.64l5.94,6.48c.1.11.23.16.37.16.12,0,.24-.04.34-.13.2-.19.22-.5.03-.71h0ZM1,7.5C1,3.92,3.92,1,7.5,1s6.5,2.92,6.5,6.5-2.92,6.5-6.5,6.5S1,11.08,1,7.5Z"
      />
    </g>
  </svg>
)

export const ArrowDropDownIcon: FC<IconProps> = (props) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M0 3L6 9L12 3H0Z" fill="#595958" />
  </svg>
)

export const ChevronDownIcon: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill={props.fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_8978_36293)">
      <path
        d="M0.398926 4.89902C0.398926 4.79502 0.438926 4.69102 0.518926 4.61902C0.670926 4.45902 0.926926 4.45902 1.07893 4.61902L7.99893 11.539L14.9189 4.61902C15.0709 4.45902 15.3269 4.45902 15.4869 4.61902C15.6389 4.77102 15.6389 5.02702 15.4869 5.18702L8.28693 12.387C8.13493 12.539 7.87893 12.539 7.71893 12.387L0.518926 5.17902C0.438926 5.09902 0.398926 4.99502 0.398926 4.89902Z"
        fill={props.fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_8978_36293">
        <rect
          width="15.202"
          height="8.002"
          fill="white"
          transform="translate(0.398926 4.49902)"
        />
      </clipPath>
    </defs>
  </svg>
)

export const ChevronUpIcon: FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill={props.fill}
    {...props}
  >
    <path
      d="M0 6.8351C0 6.91716 0.0315623 6.99922 0.094687 7.05603C0.214624 7.18228 0.416623 7.18228 0.542872 7.05603L5.99684 1.60206L11.4571 7.06235C11.5834 7.18859 11.7791 7.18859 11.9053 7.06235C12.0316 6.94241 12.0316 6.74041 11.9053 6.61416L6.21778 0.93294C6.09784 0.813003 5.89584 0.813003 5.7696 0.93294L0.094687 6.61416C0.0315623 6.67728 0 6.75935 0 6.8351Z"
      fill={props.fill}
    />
  </svg>
)

export const ChevronLeftIcon: FC<IconProps> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={props.fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.786 19.992c.109 0 .218-.043.294-.127a.432.432 0 0 0 0-.597L8.812 12l7.268-7.277a.432.432 0 0 0 0-.597.416.416 0 0 0-.597 0l-7.563 7.58a.432.432 0 0 0 0 .597l7.571 7.57a.423.423 0 0 0 .295.127v-.008z"
      fill={props.fill}
    />
  </svg>
)

export const ChevronRightIcon: FC<IconProps> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={props.fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.214 20a.395.395 0 0 1-.295-.126.432.432 0 0 1 0-.598l7.284-7.284L7.92 4.716a.407.407 0 0 1 0-.59.407.407 0 0 1 .59 0l7.578 7.58c.16.16.16.429 0 .597l-7.578 7.57a.423.423 0 0 1-.295.127z"
      fill={props.fill}
    />
  </svg>
)

export const ChevronCheckIcon: FC<IconProps> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={props.fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.4 17.997a.375.375 0 0 1-.28-.12l-4-4a.396.396 0 0 1 0-.568.403.403 0 0 1 .568 0l3.72 3.72L19.312 6.117a.41.41 0 0 1 .568 0c.16.16.16.408 0 .568L8.68 17.877a.402.402 0 0 1-.28.12z"
      fill={props.fill}
    />
  </svg>
)

export const ChevronViewBioIcon: FC<IconProps> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.687 19a.346.346 0 0 1-.258-.11.378.378 0 0 1 0-.524l6.374-6.373-6.374-6.367a.356.356 0 0 1 0-.515.356.356 0 0 1 .516 0l6.631 6.631c.14.14.14.376 0 .523L8.945 18.89a.37.37 0 0 1-.258.11z"
      fill={props?.fill || "#053747"}
    />
  </svg>
)

export const BackArrowIcon: FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={`${props.height ?? "24px"}`}
    viewBox="0 -960 960 960"
    width={`${props.width ?? "24px"}`}
    fill={`${props.fill ?? "#e8eaed"}`}
    style={{...props.style}}
  >
    <path d="m104-480 313 313q7 7 7 17t-7 17q-7 7-17 7t-17-7L78-438q-9-9-13-20t-4-22q0-11 4-22t13-20l305-305q7-7 17-7t17 7q7 7 7 17t-7 17L104-480Z" />
  </svg>
)

export const ArticleChevronIcon: FC<IconProps> = (props) => (
  <svg
    fill={
      articleChevronColours[props.fill!]
        ? articleChevronColours[props.fill!]
        : props.fill
    }
    xmlns="http://www.w3.org/2000/svg"
    width="25px"
    height={props.height || "50px"}
    viewBox="4.5 4.5 9 9"
  >
    <polygon points="4.58,0.16 4.58,6.05 7.53,9 4.58,11.95 4.58,17.84 10.47,11.95 13.42,9 "></polygon>
  </svg>
)

export const ArrowLeftIcon: FC<IconProps> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.326 2.867c.15.15.165.387.041.553l-.041.048L5.66 7.134 9.326 10.8c.15.15.165.387.041.553l-.041.048a.425.425 0 0 1-.553.041l-.048-.041-3.967-3.967a.425.425 0 0 1-.04-.553l.04-.048 3.967-3.966a.425.425 0 0 1 .601 0z"
      fill={props.fill}
    />
  </svg>
)

export const ArrowRightIcon: FC<IconProps> = (props) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.529 3.04a.51.51 0 0 0-.05.664l.05.057 4.399 4.4-4.4 4.399a.51.51 0 0 0-.048.664l.049.057a.51.51 0 0 0 .664.05l.057-.05 4.76-4.76a.51.51 0 0 0 .05-.664l-.05-.057-4.76-4.76a.51.51 0 0 0-.721 0z"
      fill="#fff"
    />
  </svg>
)

export const PlusIcon: FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={props.fill}
  >
    <path
      d="M19.5789 11.5789H12.4211V4.42105C12.4211 4.18526 12.2358 4 12 4C11.7642 4 11.5789 4.18526 11.5789 4.42105V11.5789H4.42105C4.18526 11.5789 4 11.7642 4 12C4 12.2358 4.18526 12.4211 4.42105 12.4211H11.5789V19.5789C11.5789 19.8147 11.7642 20 12 20C12.2358 20 12.4211 19.8147 12.4211 19.5789V12.4211H19.5789C19.8147 12.4211 20 12.2358 20 12C20 11.7642 19.8147 11.5789 19.5789 11.5789Z"
      fill={props.fill}
    />
  </svg>
)

export const UploadIcon: FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={props.fill}
  >
    <path
      d="M18.7368 18.5263H5.26316C4.56421 18.5263 4 17.9621 4 17.2632V15.5789C4 15.3432 4.18526 15.1579 4.42105 15.1579C4.65684 15.1579 4.84211 15.3432 4.84211 15.5789V17.2632C4.84211 17.4989 5.02737 17.6842 5.26316 17.6842H18.7368C18.9726 17.6842 19.1579 17.4989 19.1579 17.2632V15.5789C19.1579 15.3432 19.3432 15.1579 19.5789 15.1579C19.8147 15.1579 20 15.3432 20 15.5789V17.2632C20 17.9621 19.4358 18.5263 18.7368 18.5263Z"
      fill={props.fill}
    />
    <path
      d="M16.5052 9.81053L12.2946 5.6C12.1346 5.43158 11.8652 5.43158 11.6967 5.6L7.48621 9.81053C7.32621 9.97053 7.32621 10.24 7.48621 10.4084C7.64621 10.5684 7.91568 10.5684 8.08411 10.4084L11.5788 6.91369V15.5789C11.5788 15.8147 11.7641 16 11.9999 16C12.2357 16 12.4209 15.8147 12.4209 15.5789V6.91369L15.9157 10.4084C15.9999 10.4926 16.1094 10.5347 16.2104 10.5347C16.3115 10.5347 16.4294 10.4926 16.5052 10.4084C16.6652 10.24 16.6652 9.97895 16.5052 9.81053Z"
      fill={props.fill}
    />
  </svg>
)

export const CheckIcon: FC<IconProps> = (props) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.4 18.4971C8.296 18.4971 8.192 18.4571 8.12 18.3771L4.12 14.3771C3.96 14.2251 3.96 13.9691 4.12 13.8091C4.28 13.6491 4.528 13.6571 4.688 13.8091L8.408 17.5291L19.312 6.61705C19.472 6.46505 19.72 6.46505 19.88 6.61705C20.04 6.77705 20.04 7.02505 19.88 7.18505L8.68 18.3771C8.6 18.4571 8.496 18.4971 8.4 18.4971Z"
      fill="#053747"
    />
  </svg>
)

export const PlusAltIcon: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_9038_14011)">
      <path
        d="M13.6589 2.34105C12.1516 0.833684 10.1389 0 8 0C5.86105 0 3.85684 0.833684 2.34105 2.34105C0.833684 3.85684 0 5.86105 0 8C0 10.1389 0.833684 12.1432 2.34105 13.6589C3.84842 15.1663 5.86105 16 8 16C10.1389 16 12.1432 15.1663 13.6589 13.6589C15.1747 12.1516 16 10.1389 16 8C16 5.86105 15.1663 3.85684 13.6589 2.34105ZM8 15.1579C4.05053 15.1579 0.842105 11.9495 0.842105 8C0.842105 4.05053 4.05053 0.842105 8 0.842105C11.9495 0.842105 15.1579 4.05053 15.1579 8C15.1579 11.9495 11.9495 15.1579 8 15.1579Z"
        fill="#242D35"
      />
      <path
        d="M13.0527 7.579H8.4211V2.94742C8.4211 2.71163 8.23584 2.52637 8.00005 2.52637C7.76426 2.52637 7.579 2.71163 7.579 2.94742V7.579H2.94742C2.71163 7.579 2.52637 7.76426 2.52637 8.00005C2.52637 8.23584 2.71163 8.4211 2.94742 8.4211H7.579V13.0527C7.579 13.2885 7.76426 13.4737 8.00005 13.4737C8.23584 13.4737 8.4211 13.2885 8.4211 13.0527V8.4211H13.0527C13.2885 8.4211 13.4737 8.23584 13.4737 8.00005C13.4737 7.76426 13.2885 7.579 13.0527 7.579Z"
        fill="#242D35"
      />
    </g>
    <defs>
      <clipPath id="clip0_9038_14011">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const CancelIcon: FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="33"
    viewBox="0 0 16 33"
    fill={props.fill}
  >
    <path
      d="M16 10.1114L14.3886 8.5L8 14.8886L1.61143 8.5L0 10.1114L6.38857 16.5L0 22.8886L1.61143 24.5L8 18.1114L14.3886 24.5L16 22.8886L9.61143 16.5L16 10.1114Z"
      fill={props.fill}
    />
  </svg>
)

export const DoneIcon: FC<IconProps> = (props) => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#9xii8hdd7a)">
      <path
        d="m4.479 10.564-3.31-3.051L.068 8.53l4.412 4.068 9.454-8.717-1.103-1.017-8.351 7.7z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="9xii8hdd7a">
        <path
          fill="#fff"
          transform="translate(.067 .778)"
          d="M0 0h13.867v13.907H0z"
        />
      </clipPath>
    </defs>
  </svg>
)

export const MinusAltIcon: FC<IconProps> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_9776_44672)">
      <path
        d="M13.6589 2.34105C12.1516 0.833684 10.1389 0 8 0C5.86105 0 3.85684 0.833684 2.34105 2.34105C0.833684 3.85684 0 5.86105 0 8C0 10.1389 0.833684 12.1432 2.34105 13.6589C3.84842 15.1663 5.86105 16 8 16C10.1389 16 12.1432 15.1663 13.6589 13.6589C15.1747 12.1516 16 10.1389 16 8C16 5.86105 15.1663 3.85684 13.6589 2.34105ZM8 15.1579C4.05053 15.1579 0.842105 11.9495 0.842105 8C0.842105 4.05053 4.05053 0.842105 8 0.842105C11.9495 0.842105 15.1579 4.05053 15.1579 8C15.1579 11.9495 11.9495 15.1579 8 15.1579Z"
        fill="#242D35"
      />
      <path
        d="M13.0527 8.42096H2.94742C2.71163 8.42096 2.52637 8.2357 2.52637 7.99991C2.52637 7.76412 2.71163 7.57886 2.94742 7.57886H13.0527C13.2885 7.57886 13.4737 7.76412 13.4737 7.99991C13.4737 8.2357 13.2885 8.42096 13.0527 8.42096Z"
        fill="#242D35"
      />
    </g>
    <defs>
      <clipPath id="clip0_9776_44672">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const LoadingIcon: FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill={props.fill}
  >
    <path
      d="M8 0C5.86353 0 3.85882 0.828235 2.34353 2.34353C0.828235 3.85882 0 5.86353 0 8C0 10.1365 0.828235 12.1412 2.34353 13.6565C3.84941 15.1718 5.86353 16 8 16C10.1365 16 12.1412 15.1718 13.6565 13.6565C15.1718 12.1506 16 10.1365 16 8C16 7.73647 15.7929 7.52941 15.5294 7.52941C15.2659 7.52941 15.0588 7.73647 15.0588 8C15.0588 11.8965 11.8965 15.0588 8 15.0588C4.10353 15.0588 0.941176 11.8965 0.941176 8C0.941176 4.10353 4.11294 0.865882 8 0.941176C8.18824 0.941176 8.56471 0.837647 8.56471 0.461176C8.56471 0.0847059 8.17882 0 8 0Z"
      fill={props.fill}
    />
  </svg>
)

export const QuestionIcon: FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={props.fill}
  >
    <path
      d="M17.6589 6.34105C16.1516 4.83368 14.1389 4 12 4C9.86105 4 7.85684 4.83368 6.34105 6.34105C4.83368 7.85684 4 9.86105 4 12C4 14.1389 4.83368 16.1432 6.34105 17.6589C7.84842 19.1663 9.86105 20 12 20C14.1389 20 16.1432 19.1663 17.6589 17.6589C19.1747 16.1516 20 14.1389 20 12C20 9.86105 19.1663 7.85684 17.6589 6.34105ZM12 19.1579C8.05053 19.1579 4.84211 15.9495 4.84211 12C4.84211 8.05053 8.05053 4.84211 12 4.84211C15.9495 4.84211 19.1579 8.05053 19.1579 12C19.1579 15.9495 15.9495 19.1579 12 19.1579Z"
      fill={props.fill}
    />
    <path
      d="M12.0451 14.4436C11.8556 14.4436 11.7068 14.2947 11.7068 14.1053V12.7519C11.7068 12.5624 11.8556 12.4135 12.0451 12.4135C13.3511 12.4135 14.4135 11.3511 14.4135 10.0451C14.4135 8.7391 13.3511 7.67669 12.0451 7.67669C10.7391 7.67669 9.67669 8.7391 9.67669 10.0451C9.67669 10.2346 9.52782 10.3835 9.33835 10.3835C9.14887 10.3835 9 10.2346 9 10.0451C9 8.36692 10.3669 7 12.0451 7C13.7233 7 15.0902 8.36692 15.0902 10.0451C15.0902 11.6083 13.906 12.9007 12.3835 13.0699V14.1053C12.3835 14.2947 12.2346 14.4436 12.0451 14.4436Z"
      fill={props.fill}
    />
    <path
      d="M12.0454 16.4737C11.8559 16.4737 11.707 16.3249 11.707 16.1354V15.4587C11.707 15.2692 11.8559 15.1204 12.0454 15.1204C12.2349 15.1204 12.3837 15.2692 12.3837 15.4587V16.1354C12.3837 16.3249 12.2349 16.4737 12.0454 16.4737Z"
      fill={props.fill}
    />
  </svg>
)

export const WarningIcon: FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "14"}
    height={props.height || "14"}
    viewBox={`0 0 ${props.width || "14"} ${props.height || "14"}`}
    fill={props.fill}
  >
    <path
      d="M13.619 13.2582H0.36629C0.233763 13.2582 0.115961 13.192 0.0496976 13.0742C-0.0165659 12.9637 -0.0165659 12.8238 0.0496976 12.706L6.67604 0.925856C6.74231 0.808054 6.86011 0.741791 7 0.741791C7.13989 0.741791 7.25769 0.815417 7.32395 0.925856L13.9503 12.706C14.0166 12.8238 14.0166 12.9564 13.9503 13.0742C13.884 13.1846 13.7662 13.2582 13.6337 13.2582H13.619ZM0.999474 12.522H12.9932L6.99264 1.86091L0.999474 12.522Z"
      fill={props.fill}
    />
    <path
      d="M6.99258 9.57694C6.78643 9.57694 6.62445 9.41497 6.62445 9.20881V5.52751C6.62445 5.32136 6.78643 5.15938 6.99258 5.15938C7.19873 5.15938 7.36071 5.32136 7.36071 5.52751V9.20881C7.36071 9.41497 7.19873 9.57694 6.99258 9.57694Z"
      fill={props.fill}
    />
    <path
      d="M6.99258 11.7857C6.78643 11.7857 6.62445 11.6237 6.62445 11.4176V10.6813C6.62445 10.4751 6.78643 10.3132 6.99258 10.3132C7.19873 10.3132 7.36071 10.4751 7.36071 10.6813V11.4176C7.36071 11.6237 7.19873 11.7857 6.99258 11.7857Z"
      fill={props.fill}
    />
  </svg>
)

export const WarningIcon2: FC<IconProps> = (props) => (
  <svg
    width={props.width || "14"}
    height={props.height || "14"}
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#l632a1z4qa)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.198 2.333a.22.22 0 0 0-.388 0L1.342 12.716a.219.219 0 0 0 .194.321h10.937c.165 0 .27-.175.193-.32L7.198 2.332zm-1.551-.612c.575-1.092 2.14-1.092 2.715 0l5.468 10.383a1.533 1.533 0 0 1-1.357 2.247H1.536A1.533 1.533 0 0 1 .18 12.104L5.647 1.721zM7.004 5.43c.363 0 .658.294.658.657v2.075a.657.657 0 0 1-1.315 0V6.087c0-.363.294-.657.657-.657zm-.657 5.498c0-.363.294-.657.657-.657h.007a.657.657 0 1 1 0 1.314h-.007a.657.657 0 0 1-.657-.657z"
        fill="#F98500"
      />
    </g>
    <defs>
      <clipPath id="l632a1z4qa">
        <path fill="#fff" transform="translate(0 .5)" d="M0 0h14v14H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const BinIcon: FC<IconProps> = (props) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.7998 6.1H14.1998L13.1198 4.66C13.0478 4.556 12.9278 4.5 12.7998 4.5H11.1998C11.0718 4.5 10.9518 4.556 10.8798 4.66L9.7998 6.1H5.1998C4.9758 6.1 4.7998 6.276 4.7998 6.5C4.7998 6.724 4.9758 6.9 5.1998 6.9H18.7998C19.0238 6.9 19.1998 6.724 19.1998 6.5C19.1998 6.276 19.0238 6.1 18.7998 6.1ZM11.3998 5.3H12.5998L13.1998 6.1H10.7998L11.3998 5.3Z"
      fill="#DB0D00"
    />
    <path
      d="M18.0634 7.70757C17.8474 7.67557 17.6394 7.81957 17.5994 8.03557L15.7274 19.2436C15.6874 19.4836 15.4394 19.6996 15.1914 19.6996H8.79944C8.55144 19.6996 8.30344 19.4836 8.26344 19.2436L6.39144 8.03557C6.35944 7.81957 6.15144 7.66757 5.92744 7.70757C5.70344 7.74757 5.55944 7.94757 5.59944 8.17157L7.47144 19.3796C7.57544 20.0116 8.15944 20.4996 8.79944 20.4996H15.1994C15.8394 20.4996 16.4234 20.0036 16.5274 19.3796L18.3994 8.17157C18.4314 7.95557 18.2874 7.74757 18.0714 7.70757H18.0634Z"
      fill="#DB0D00"
    />
  </svg>
)

export const DownloadIcon: FC<IconProps> = (props) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.5051 11.7842C16.3451 11.6242 16.0756 11.6242 15.9072 11.7842L12.4125 15.2789V5.76315C12.4125 5.52737 12.2272 5.3421 11.9914 5.3421C11.7556 5.3421 11.5704 5.52737 11.5704 5.76315V15.2705L8.07562 11.7758C7.91562 11.6158 7.64615 11.6158 7.47773 11.7758C7.31773 11.9442 7.31773 12.2053 7.47773 12.3737L11.6883 16.5842C11.7725 16.6684 11.8819 16.7105 11.983 16.7105C12.084 16.7105 12.2019 16.6684 12.2777 16.5842L16.4883 12.3737C16.6483 12.2053 16.6483 11.9442 16.4883 11.7758L16.5051 11.7842Z"
      fill="#595958"
    />
    <path
      d="M18.7368 19.6579H5.26316C4.56421 19.6579 4 19.0937 4 18.3948V16.7105C4 16.4748 4.18526 16.2895 4.42105 16.2895C4.65684 16.2895 4.84211 16.4748 4.84211 16.7105V18.3948C4.84211 18.6305 5.02737 18.8158 5.26316 18.8158H18.7368C18.9726 18.8158 19.1579 18.6305 19.1579 18.3948V16.7105C19.1579 16.4748 19.3432 16.2895 19.5789 16.2895C19.8147 16.2895 20 16.4748 20 16.7105V18.3948C20 19.0937 19.4358 19.6579 18.7368 19.6579Z"
      fill="#595958"
    />
  </svg>
)

export const CloseIcon: FC<IconProps> = (props) => (
  <svg
    width={props.width || "24"}
    height={props.height || "24"}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.5976 11.9968L19.8686 4.71742C20.0369 4.55753 20.0369 4.28823 19.8686 4.11992C19.7087 3.96003 19.4394 3.96003 19.2711 4.11992L11.9917 11.3993L4.72069 4.12834C4.5608 3.96003 4.2915 3.96003 4.1316 4.12834C3.97171 4.29665 3.96329 4.55753 4.1316 4.71742L11.411 11.9968L4.1316 19.2763C3.96329 19.4362 3.96329 19.7055 4.1316 19.8738C4.21576 19.9579 4.32516 20 4.42615 20C4.52713 20 4.64495 19.9579 4.72069 19.8738L12.0001 12.5943L19.2795 19.8738C19.3637 19.9579 19.4731 20 19.5741 20C19.6751 20 19.7929 19.9579 19.8686 19.8738C20.0285 19.7055 20.0285 19.4446 19.8686 19.2763L12.5892 11.9968H12.5976Z"
      fill={props.fill || "#6A6A69"}
    />
  </svg>
)

export const CloseModalIcon: FC<IconProps> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m12.598 11.997 7.27-7.28a.417.417 0 0 0 0-.597.432.432 0 0 0-.597 0l-7.28 7.28-7.27-7.272a.407.407 0 0 0-.59 0c-.16.169-.168.43 0 .59l7.28 7.279-7.28 7.28a.417.417 0 0 0 0 .597.408.408 0 0 0 .59 0L12 12.594l7.28 7.28a.408.408 0 0 0 .59 0 .432.432 0 0 0-.002-.598l-7.279-7.28h.008z"
      fill="#595958"
    />
  </svg>
)

export const ListOrdered: FC<IconProps> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.5 4.3676H5.5C5.22 4.3676 5 4.19391 5 3.97286C5 3.75181 5.22 3.57812 5.5 3.57812H19.5C19.78 3.57812 20 3.75181 20 3.97286C20 4.19391 19.78 4.3676 19.5 4.3676Z"
      fill="inherit"
    />
    <path
      d="M19.5 9.89494H5.5C5.22 9.89494 5 9.72126 5 9.50021C5 9.27915 5.22 9.10547 5.5 9.10547H19.5C19.78 9.10547 20 9.27915 20 9.50021C20 9.72126 19.78 9.89494 19.5 9.89494Z"
      fill="inherit"
    />
    <path
      d="M19.5 15.4203H5.5C5.22 15.4203 5 15.2466 5 15.0256C5 14.8045 5.22 14.6309 5.5 14.6309H19.5C19.78 14.6309 20 14.8045 20 15.0256C20 15.2466 19.78 15.4203 19.5 15.4203Z"
      fill="inherit"
    />
    <path
      d="M1.5 5.94737C1.22 5.94737 1 5.77368 1 5.55263V2.78947H0.5C0.22 2.78947 0 2.61579 0 2.39474C0 2.17368 0.22 2 0.5 2H1.5C1.78 2 2 2.17368 2 2.39474V5.55263C2 5.77368 1.78 5.94737 1.5 5.94737Z"
      fill="inherit"
    />
    <path
      d="M2.5 11.4728H0.5C0.22 11.4728 0 11.2991 0 11.078V9.49907C0 9.27802 0.22 9.10434 0.5 9.10434H2V8.31486H0.5C0.22 8.31486 0 8.14118 0 7.92013C0 7.69907 0.22 7.52539 0.5 7.52539H2.5C2.78 7.52539 3 7.69907 3 7.92013V9.49907C3 9.72013 2.78 9.89381 2.5 9.89381H1V10.6833H2.5C2.78 10.6833 3 10.857 3 11.078C3 11.2991 2.78 11.4728 2.5 11.4728Z"
      fill="inherit"
    />
    <path
      d="M2.5 13.0527H0.5C0.22 13.0527 0 13.2264 0 13.4475C0 13.6685 0.22 13.8422 0.5 13.8422H2V14.6317H0.5C0.22 14.6317 0 14.8054 0 15.0264C0 15.2475 0.22 15.4212 0.5 15.4212H2V16.2106H0.5C0.22 16.2106 0 16.3843 0 16.6054C0 16.8264 0.22 17.0001 0.5 17.0001H2.5C2.78 17.0001 3 16.8264 3 16.6054V13.4475C3 13.2264 2.78 13.0527 2.5 13.0527Z"
      fill="inherit"
    />
  </svg>
)

export const ListBulleted: FC<IconProps> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.5 15.5H4.5C4.22 15.5 4 15.28 4 15C4 14.72 4.22 14.5 4.5 14.5H19.5C19.78 14.5 20 14.72 20 15C20 15.28 19.78 15.5 19.5 15.5Z"
      fill="inherit"
    />
    <path
      d="M19.5 10.5H4.5C4.22 10.5 4 10.28 4 10C4 9.72 4.22 9.5 4.5 9.5H19.5C19.78 9.5 20 9.72 20 10C20 10.28 19.78 10.5 19.5 10.5Z"
      fill="inherit"
    />
    <path
      d="M19.5 5.5H4.5C4.22 5.5 4 5.28 4 5C4 4.72 4.22 4.5 4.5 4.5H19.5C19.78 4.5 20 4.72 20 5C20 5.28 19.78 5.5 19.5 5.5Z"
      fill="inherit"
    />
    <path
      d="M1.5 6.5C0.67 6.5 0 5.83 0 5C0 4.17 0.67 3.5 1.5 3.5C2.33 3.5 3 4.17 3 5C3 5.83 2.33 6.5 1.5 6.5ZM1.5 4.5C1.22 4.5 1 4.72 1 5C1 5.28 1.22 5.5 1.5 5.5C1.78 5.5 2 5.28 2 5C2 4.72 1.78 4.5 1.5 4.5Z"
      fill="inherit"
    />
    <path
      d="M1.5 11.5C0.67 11.5 0 10.83 0 10C0 9.17 0.67 8.5 1.5 8.5C2.33 8.5 3 9.17 3 10C3 10.83 2.33 11.5 1.5 11.5ZM1.5 9.5C1.22 9.5 1 9.72 1 10C1 10.28 1.22 10.5 1.5 10.5C1.78 10.5 2 10.28 2 10C2 9.72 1.78 9.5 1.5 9.5Z"
      fill="inherit"
    />
    <path
      d="M1.5 16.5C0.67 16.5 0 15.83 0 15C0 14.17 0.67 13.5 1.5 13.5C2.33 13.5 3 14.17 3 15C3 15.83 2.33 16.5 1.5 16.5ZM1.5 14.5C1.22 14.5 1 14.72 1 15C1 15.28 1.22 15.5 1.5 15.5C1.78 15.5 2 15.28 2 15C2 14.72 1.78 14.5 1.5 14.5Z"
      fill="inherit"
    />
  </svg>
)

export const FontItalic: FC<IconProps> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.5 2H11.499H11.495H7.5C7.224 2 7 2.224 7 2.5C7 2.776 7.224 3 7.5 3H10.89L8.09 17H4.5C4.224 17 4 17.224 4 17.5C4 17.776 4.224 18 4.5 18H8.499H8.501H8.503H12.5C12.776 18 13 17.776 13 17.5C13 17.224 12.776 17 12.5 17H9.11L11.91 3H15.5C15.776 3 16 2.776 16 2.5C16 2.224 15.776 2 15.5 2Z"
      fill="inherit"
    />
  </svg>
)

export const FontBold: FC<IconProps> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 9H7.5C7.224 9 7 8.776 7 8.5V5.5C7 5.224 7.224 5 7.5 5H10C11.103 5 12 5.897 12 7C12 8.103 11.103 9 10 9ZM8 8H10C10.551 8 11 7.551 11 7C11 6.449 10.551 6 10 6H8V8Z"
      fill="inherit"
    />
    <path
      d="M11 15H7.5C7.224 15 7 14.776 7 14.5V11.5C7 11.224 7.224 11 7.5 11H11C12.103 11 13 11.897 13 13C13 14.103 12.103 15 11 15ZM8 14H11C11.551 14 12 13.551 12 13C12 12.449 11.551 12 11 12H8V14Z"
      fill="inherit"
    />
    <path
      d="M11 18H5.5C4.673 18 4 17.327 4 16.5V3.5C4 2.673 4.673 2 5.5 2H10C12.757 2 15 4.243 15 7C15 7.824 14.798 8.628 14.413 9.349C15.426 10.294 16 11.602 16 13C16 15.757 13.757 18 11 18ZM5.5 3C5.224 3 5 3.224 5 3.5V16.5C5 16.776 5.224 17 5.5 17H11C13.206 17 15 15.206 15 13C15 11.763 14.439 10.615 13.461 9.849C13.25 9.684 13.208 9.383 13.361 9.167C13.779 8.521 14 7.772 14 7C14 4.794 12.206 3 10 3H5.5Z"
      fill="inherit"
    />
  </svg>
)

export const FontUnderline: FC<IconProps> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.5 18H5.5C5.224 18 5 17.776 5 17.5C5 17.224 5.224 17 5.5 17H14.5C14.776 17 15 17.224 15 17.5C15 17.776 14.776 18 14.5 18Z"
      fill="inherit"
    />
    <path
      d="M10 15C7.243 15 5 12.757 5 10V2.5C5 2.224 5.224 2 5.5 2C5.776 2 6 2.224 6 2.5V10C6 12.206 7.794 14 10 14C12.206 14 14 12.206 14 10V2.5C14 2.224 14.224 2 14.5 2C14.776 2 15 2.224 15 2.5V10C15 12.757 12.757 15 10 15Z"
      fill="inherit"
    />
  </svg>
)

export const ArrowNext: FC<IconProps> = (props) => (
  <svg
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.83641 6.07128H0.585571V4.27267H7.83641L5.05551 1.31136L6.24983 0.0395508L11.0696 5.17198L6.24983 10.3044L5.05551 9.0326L7.83641 6.07128Z"
      fill={props.color}
    />
  </svg>
)

export const ArrowPrev: FC<IconProps> = (props) => (
  <svg
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.93223 4.30617H11.3708V6.03893H3.93223L6.78512 8.89182L5.55988 10.1171L0.615356 5.17255L5.55988 0.228027L6.78512 1.45327L3.93223 4.30617Z"
      fill={props.color}
    />
  </svg>
)

export const Pencil: FC<IconProps> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.399 19.992a.375.375 0 0 1-.28-.12.403.403 0 0 1-.096-.416l1.6-4.4a.454.454 0 0 1 .096-.143L16.517 4.114a.41.41 0 0 1 .568 0l2.8 2.8a.41.41 0 0 1 0 .568L9.086 18.28a.454.454 0 0 1-.144.096l-4.4 1.6a.406.406 0 0 1-.135.024l-.008-.008zm1.944-4.583-1.28 3.511 3.511-1.28L19.03 7.194l-2.232-2.232L6.343 15.409z"
      fill="#053747"
    />
  </svg>
)

export const Mail: FC<IconProps> = (props) => (
  <svg
    width={props?.width || "25px"}
    height={props?.height || "24px"}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.237 6.947H5.763c-.699 0-1.263.565-1.263 1.264v7.579c0 .698.564 1.263 1.263 1.263h13.474c.699 0 1.263-.565 1.263-1.264V8.212c0-.7-.564-1.264-1.263-1.264zm0 .842h.076l-6.341 4.228c-.245.16-.69.16-.935 0l-6.35-4.22h13.55V7.79zm0 8.421H5.763a.417.417 0 0 1-.42-.42V8.573l6.222 4.151c.261.177.598.261.935.261.337 0 .674-.084.935-.26l6.223-4.152v7.216a.417.417 0 0 1-.421.421z"
      fill={props?.fill || "#053747"}
    />
  </svg>
)

export const BookMark: FC<IconProps> = (props) => (
  <svg
    width={props?.width || "25px"}
    height={props?.height || "24px"}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.051 19.996a.435.435 0 0 1-.32-.144L12 14.33l-4.731 5.522a.408.408 0 0 1-.463.118.418.418 0 0 1-.278-.395V4.42c0-.236.185-.421.42-.421h10.103c.236 0 .421.185.421.42v15.155a.418.418 0 0 1-.42.42zM12 13.26c.126 0 .244.05.32.143l4.31 5.026V4.842H7.37v13.596l4.31-5.026a.409.409 0 0 1 .32-.143v-.008z"
      fill={props?.fill || "#053747"}
    />
  </svg>
)

export const ReportProblemIcon: FC<IconProps> = (props) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3047_11227)">
      <path
        d="M0 13.3H14L7 1.40002L0 13.3ZM7.63636 11.4211H6.36364V10.1684H7.63636V11.4211ZM7.63636 8.91581H6.36364V6.41055H7.63636V8.91581Z"
        fill="#DB0D00"
      />
    </g>
    <defs>
      <clipPath id="clip0_3047_11227">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const DownloadAltIcon: FC<IconProps> = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#n8mdv09fpa)" fill="#fff">
      <path d="M14.068 8.195a.486.486 0 0 0-.672 0l-3.932 3.931V1.421A.47.47 0 0 0 8.99.947a.47.47 0 0 0-.473.474v10.696L4.585 8.185a.486.486 0 0 0-.673 0 .486.486 0 0 0 0 .673l4.737 4.737a.46.46 0 0 0 .663 0l4.737-4.737a.486.486 0 0 0 0-.673l.02.01z" />
      <path d="M16.579 17.053H1.42A1.42 1.42 0 0 1 0 15.633v-1.896a.47.47 0 0 1 .474-.473.47.47 0 0 1 .473.473v1.895a.47.47 0 0 0 .474.474H16.58a.47.47 0 0 0 .474-.474v-1.895a.47.47 0 0 1 .473-.473.47.47 0 0 1 .474.473v1.895a1.42 1.42 0 0 1-1.421 1.421z" />
    </g>
    <defs>
      <clipPath id="n8mdv09fpa">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const InfoIcon: FC<IconProps> = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask id="hak3lhlbca" fill="#fff">
      <path d="M17.659 6.341A7.956 7.956 0 0 0 12 4a7.97 7.97 0 0 0-5.659 2.341A7.97 7.97 0 0 0 4 12a7.97 7.97 0 0 0 2.341 5.659A7.956 7.956 0 0 0 12 20a7.97 7.97 0 0 0 5.659-2.341A7.92 7.92 0 0 0 20 12a7.97 7.97 0 0 0-2.341-5.659zM12 19.158A7.163 7.163 0 0 1 4.842 12 7.163 7.163 0 0 1 12 4.842 7.163 7.163 0 0 1 19.158 12 7.163 7.163 0 0 1 12 19.158z" />
    </mask>
    <path
      d="M17.659 6.341A7.956 7.956 0 0 0 12 4a7.97 7.97 0 0 0-5.659 2.341A7.97 7.97 0 0 0 4 12a7.97 7.97 0 0 0 2.341 5.659A7.956 7.956 0 0 0 12 20a7.97 7.97 0 0 0 5.659-2.341A7.92 7.92 0 0 0 20 12a7.97 7.97 0 0 0-2.341-5.659zM12 19.158A7.163 7.163 0 0 1 4.842 12 7.163 7.163 0 0 1 12 4.842 7.163 7.163 0 0 1 19.158 12 7.163 7.163 0 0 1 12 19.158z"
      fill="#053747"
    />
    <path
      d="m17.659 6.341.709-.705-.002-.002-.707.707zm-11.318 0-.705-.709-.004.004.71.705zm0 11.318-.709.705.002.002.707-.707zM18.366 5.634A8.956 8.956 0 0 0 12 3v2c1.874 0 3.632.729 4.952 2.048l1.414-1.414zM12 3a8.97 8.97 0 0 0-6.364 2.632l1.41 1.418A6.97 6.97 0 0 1 12 5V3zM5.632 5.636A8.97 8.97 0 0 0 3 12h2a6.97 6.97 0 0 1 2.05-4.954l-1.418-1.41zM3 12a8.97 8.97 0 0 0 2.632 6.364l1.418-1.41A6.97 6.97 0 0 1 5 12H3zm2.634 6.366A8.956 8.956 0 0 0 12 21v-2a6.956 6.956 0 0 1-4.952-2.048l-1.414 1.414zM12 21a8.97 8.97 0 0 0 6.364-2.632l-1.41-1.418A6.97 6.97 0 0 1 12 19v2zm6.364-2.632A8.92 8.92 0 0 0 21 12h-2a6.921 6.921 0 0 1-2.046 4.95l1.41 1.418zM21 12a8.97 8.97 0 0 0-2.632-6.364l-1.418 1.41A6.97 6.97 0 0 1 19 12h2zm-9 6.158A6.163 6.163 0 0 1 5.842 12h-2A8.163 8.163 0 0 0 12 20.158v-2zM5.842 12A6.163 6.163 0 0 1 12 5.842v-2A8.163 8.163 0 0 0 3.842 12h2zM12 5.842A6.163 6.163 0 0 1 18.158 12h2A8.163 8.163 0 0 0 12 3.842v2zM18.158 12A6.163 6.163 0 0 1 12 18.158v2A8.163 8.163 0 0 0 20.158 12h-2z"
      fill="#595958"
      mask="url(#hak3lhlbca)"
    />
    <mask id="roxexytdnb" fill="#fff">
      <path d="M12 7.788c.236 0 .421.126.421.286v.564c0 .152-.185.286-.42.286-.237 0-.422-.126-.422-.286v-.564c0-.152.185-.286.421-.286z" />
    </mask>
    <path
      d="M12 7.788c.236 0 .421.126.421.286v.564c0 .152-.185.286-.42.286-.237 0-.422-.126-.422-.286v-.564c0-.152.185-.286.421-.286z"
      fill="#053747"
    />
    <path
      d="M12 8.788a.472.472 0 0 1-.264-.09.754.754 0 0 1-.315-.624h2c0-.5-.293-.85-.56-1.03a1.533 1.533 0 0 0-.86-.256v2zm-.579-.714v.564h2v-.564h-2zm0 .564c0-.354.211-.554.308-.621A.477.477 0 0 1 12 7.924v2c.3 0 .61-.084.87-.265.248-.172.551-.515.551-1.02h-2zm.58-.714c.05 0 .148.012.263.09a.754.754 0 0 1 .315.624h-2c0 .5.294.85.56 1.03.266.181.575.256.861.256v-2zm.578.714v-.564h-2v.564h2zm0-.564c0 .354-.21.554-.307.621a.476.476 0 0 1-.272.093v-2c-.3 0-.61.084-.87.265-.247.172-.55.515-.55 1.02h2z"
      fill="#595958"
      mask="url(#roxexytdnb)"
    />
    <path
      d="M12 9.743c.236 0 .421.126.421.287v5.642c0 .16-.185.286-.42.286-.237 0-.422-.126-.422-.286v-5.643c0-.151.185-.286.421-.286z"
      fill="#053747"
    />
  </svg>
)
